import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { HttpClient } from '@angular/common/http';
import { ConfigurationTicketsListPage } from '../../../configuration/configuration-tickets/configuration-tickets-list/configuration-tickets-list';
import { InvoicesViewPage } from '../../../invoices/invoices-view/invoices-view';
import { SalesListPage } from '../../../sales/sales-list/sales-list';

/**
 * Generated class for the HomeDashboardLastTicketsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-home-dashboard-last-tickets',
  templateUrl: 'home-dashboard-last-tickets.html',
})
export class HomeDashboardLastTicketsPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public http: HttpClient, ) {

    this.lastTicketsPayed();
    this.lastInvoicesConfirm();
  }

  tickets: any = [];
  invoices: any = [];
  data_tickets: boolean = false;
  data_invoices: boolean = false;

  async lastTicketsPayed() {

    await this.http.post(this.globals.analytics_path + 'last-tickets-payed/' + this.globals.restaurant_uid, {}).subscribe(async data => {
      this.tickets = data;
      this.data_tickets = true;
    },
      err => {
      }
    );
  }
  async lastInvoicesConfirm() {

    await this.http.post(this.globals.analytics_path + 'last-invoices-confirm/' + this.globals.restaurant_uid, {}).subscribe(async data => {
      this.invoices = data;
      this.data_invoices = true;
    },
      err => {
      }
    );
  }
  openTicket(ticket) {
    this.globals.side_menu_config_active = 'tickets';
    this.navCtrl.push(ConfigurationTicketsListPage, {
      state: 'closed',
      ticket: ticket,
    });
  }
  openInvoices(invoice) {
    this.navCtrl.push(InvoicesViewPage, {
      'type': 'pay',
      'invoice': invoice,
    });
  }
  openSales(){
    this.navCtrl.push(SalesListPage);
    this.globals.side_menu_active = 'sales';
  }

  trFontColor(ticket) {
    if (ticket.refund && ticket.amount < 0) {
      let cssClasses = {
        'text-danger': true,
      };
      return cssClasses;
    }
    return '';
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home-dashboard/home-dashboard-last-tickets/home-dashboard-last-tickets.ts